import Box from '@paperstac/ui/lib/Box';
import Container from '@paperstac/ui/lib/Container';
import LinkButton from '@paperstac/ui/lib/LinkButton';
import PageTitle from '@paperstac/ui/lib/PageTitle';
import Text from '@paperstac/ui/lib/Text';
import React from 'react';
import LoadingMessage from '../../common/LoadingMessage';
import ManageListingOverlay from '../../common/ManageListingOverlay/ManageListingOverlay';
import CreateListingOverlay from './CreateListingOverlay';
import Listing from './Listing';
import Meta from './Meta';
import { MyListingsPageContext } from './MyListingsPageProvider';
import ViewTransactionsOverlay from './ViewTransactionsOverlay';
import VerifyIdentityOverlay from '../../common/VerifyIdentityOverlay/VerifyIdentityOverlay';
import { IdentityContext } from '@paperstac/common/lib/components/IdentityProvider';
import ServicerLoanImporter from './ServicerLoanImporter';

const Content = React.memo((props) => {
  const {
    createVisible,
    hideManageListing,
    hideVerify,
    listingToManage,
    listings,
    setShowImporter,
    showCreate,
    showImporter,
    startImport,
    transactionsToView,
    verifyVisible,
  } = React.useContext(MyListingsPageContext);

  const { claims } = React.useContext(IdentityContext);

  if (showImporter) return <ServicerLoanImporter />;

  return (
    <Container>
      <PageTitle my={5} textAlign="left">
        My Listings
      </PageTitle>

      <Box mb={3}>
        <LinkButton onClick={showCreate}>
          <Text variant="bold">+</Text> Create New Listing
        </LinkButton>
      </Box>

      <Box mb={3}>
        <LinkButton onClick={() => setShowImporter(true)}>
          <Text variant="bold">+</Text> Import From Servicer
        </LinkButton>
      </Box>
      {!!claims?.admin && (
        <Box mb={5}>
          <LinkButton onClick={startImport}>
            <Text variant="bold">+</Text> Import Tape/Spreadsheet
          </LinkButton>
        </Box>
      )}

      <Meta mb={5} />

      {!listings && <LoadingMessage />}

      {!!listings && (
        <>
          <Box mb={5}>
            <Text variant="bold">{listings.length}</Text> {listings.length === 1 ? 'listing' : 'listings'} returned
          </Box>
          <Box mb={6}>
            {listings.map((listing) => (
              <Listing key={listing.id} listing={listing} />
            ))}
          </Box>
        </>
      )}

      {!!transactionsToView.length && <ViewTransactionsOverlay />}

      {!!createVisible && <CreateListingOverlay />}

      {!!verifyVisible && <VerifyIdentityOverlay onClose={hideVerify} />}

      {!!listingToManage && <ManageListingOverlay listing={listingToManage} onClose={hideManageListing} />}
    </Container>
  );
});

Content.propTypes = {};

Content.defaultProps = {};

Content.displayName = 'Content';

export default Content;
